module.exports = __webpack_public_path__ + "img/gyrocopter_small.cb78c208.png";